// Configuration constants
export const MAX_OPEN_TABS = 5;
export const SANDBOX_WORKSPACE_PATH = "/home/user/workspace"; // No trailing slash to match original
export const NOTIFICATION_TIMEOUT = 3000;
export const EDITOR_HEIGHT = "calc(100vh - 215px)"; // Adjusted for visible tabs (53px height)

// File type to icon color mapping
export const FILE_TYPE_COLORS = {
  js: "text-yellow-500 dark:text-yellow-400",
  jsx: "text-blue-500 dark:text-neutral-400",
  ts: "text-blue-600 dark:text-neutral-500",
  tsx: "text-blue-600 dark:text-neutral-500",
  css: "text-purple-500 dark:text-purple-400",
  scss: "text-purple-500 dark:text-purple-400",
  json: "text-green-500 dark:text-green-400",
  html: "text-orange-500 dark:text-orange-400",
  md: "text-blue-300 dark:text-neutral-300",
  jpg: "text-pink-500 dark:text-pink-400",
  jpeg: "text-pink-500 dark:text-pink-400",
  png: "text-pink-500 dark:text-pink-400",
  gif: "text-pink-500 dark:text-pink-400",
  svg: "text-pink-500 dark:text-pink-400",
  default: "text-neutral-400 dark:text-neutral-500",
};

// File extension to Monaco language mapping
export const LANGUAGE_MAP = {
  js: "javascript",
  jsx: "javascript",
  ts: "typescript",
  tsx: "typescript",
  py: "python",
  java: "java",
  c: "c",
  cpp: "cpp",
  cc: "cpp",
  cxx: "cpp",
  cs: "csharp",
  php: "php",
  rb: "ruby",
  go: "go",
  rs: "rust",
  kt: "kotlin",
  swift: "swift",
  m: "objective-c",
  scala: "scala",
  sh: "shell",
  bash: "shell",
  ps1: "powershell",
  psm1: "powershell",
  psd1: "powershell",
  bat: "bat",
  cmd: "bat",
  json: "json",
  xml: "xml",
  yaml: "yaml",
  yml: "yaml",
  toml: "toml",
  ini: "ini",
  cfg: "ini",
  conf: "ini",
  sql: "sql",
  mysql: "mysql",
  pgsql: "pgsql",
  html: "html",
  htm: "html",
  css: "css",
  scss: "scss",
  sass: "scss",
  less: "less",
  md: "markdown",
  markdown: "markdown",
  tex: "latex",
  dockerfile: "dockerfile",
  dockerignore: "dockerfile",
  makefile: "makefile",
  mk: "makefile",
  r: "r",
  R: "r",
  vb: "vb",
  vbs: "vbscript",
  lua: "lua",
  perl: "perl",
  pl: "perl",
};

// Monaco editor base options
export const MONACO_BASE_OPTIONS = {
  minimap: { enabled: false },
  fontSize: 13,
  wordWrap: "on",
  readOnly: false,
  lineNumbers: "on",
  renderLineHighlight: "all",
  scrollBeyondLastLine: false,
  padding: { top: 12, bottom: 12 },
  contextmenu: false, // Disable right-click context menu
};

// Monaco validation options (for disabling squiggles)
export const MONACO_VALIDATION_OPTIONS = {
  "semanticHighlighting.enabled": false,
  "bracketPairColorization.enabled": true,
  "suggest.showSnippets": false,
  "suggest.showWords": false,
  "suggest.showIcons": false,
  quickSuggestions: false,
  "parameterHints.enabled": false,
  suggestOnTriggerCharacters: false,
  acceptSuggestionOnEnter: "off",
  tabCompletion: "off",
  wordBasedSuggestions: false,
  links: false,
};

// Component size constants
export const FILE_EXPLORER_WIDTH = "w-64"; // Match database viewer width
export const FILE_ICON_SIZE = 14;
export const CLOSE_ICON_SIZE = 14;
export const REFRESH_ICON_SIZE = 12;
export const ALERT_ICON_SIZE = 14;
export const CODE_ICON_SIZE = 48;

// CSS class names for consistent styling
export const CLASSES = {
  fileExplorer:
    "w-64 h-full border-r border-neutral-200 dark:border-neutral-700 flex flex-col bg-white dark:bg-neutral-800",
  fileItem:
    "flex items-center py-1.5 px-2 hover:bg-neutral-100 dark:hover:bg-neutral-800 cursor-pointer rounded-lg transition-all duration-150",
  fileItemSelected: "bg-lime-100/60 dark:bg-lime-900/20",
  tab: "flex items-center px-4 h-full text-sm cursor-pointer transition-all duration-200 group border-r border-neutral-200 dark:border-neutral-700",
  tabActive:
    "bg-white dark:bg-neutral-800 border-t-2 border-t-lime-500 dark:border-t-lime-500",
  tabInactive:
    "bg-gray-50 dark:bg-neutral-800/50 hover:bg-gray-100 dark:hover:bg-neutral-700",
  saveButton:
    "px-3 py-1 text-xs bg-brand-action text-brand-action-text rounded-md hover:bg-brand-action-hover disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center gap-1 font-sans",
};
